import { DateTime } from 'luxon';

import { DdpToastIntroduction } from './ddp-introduction-modal';
import { DDP_MODAL_SNOOZE_KEY } from '../../../config/ddp-country-config';
import { useDdpTermsState } from '../../../hooks/use-ddp-terms-state';
import { useLocalStorage } from '../../../hooks/use-local-storage';

const useIsNotificationSnoozed = () => {
  const [snoozedUntilTimestamp] = useLocalStorage(DDP_MODAL_SNOOZE_KEY);

  if (!snoozedUntilTimestamp) {
    return false;
  }

  const snoozedUntil = DateTime.fromISO(snoozedUntilTimestamp);
  const now = DateTime.now();

  return snoozedUntil > now;
};

/**
 * Wrapper component that manages the DDP introduction and terms modals display logic
 * Shows introduction modal after login for users with wallet configured,
 * then shows terms modal for users with UPS, FedEx, DHL Express carriers (Wallet or BYOA)
 * @returns {React.JSX.Element|null}
 */
export const DdpToastWrapper = () => {
  const { isAcceptanceRequired } = useDdpTermsState();
  const isNotificationSnoozed = useIsNotificationSnoozed();

  if (isAcceptanceRequired && !isNotificationSnoozed) {
    return <DdpToastIntroduction />;
  }

  return null;
};
